export { MAX_WIDTH_MESSAGE_DESKTOP, MAX_WIDTH_MESSAGE_MOBILE } from './constants';
